import { ICoordinate } from "@ryde/shared";

export const landingIsStringCoordinate = (latLngString: string): boolean => {
  const latLngPattern = /^\d+\.\d+,\s*\d+\.\d+$/;
  return latLngPattern.test(latLngString);
};

export const landingConvertStringCoordinate = (
  latLngString: string,
): ICoordinate | object => {
  if (landingIsStringCoordinate(latLngString)) {
    const [lat, lng] = latLngString.split(",").map(Number);
    const coordinate: ICoordinate = {
      lat,
      lng,
    };
    return coordinate;
  }

  return {};
};
